import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MediaService } from '../services/media.service';

@Pipe({
  name: 'thumbnail',
})
export class ThumbnailPipe implements PipeTransform {
  constructor(private mediaService: MediaService) {}

  transform(filename: string, size: string, fullPath?: boolean): unknown {
    if (!filename) return '';
    return this.mediaService.getThumbPath(filename, size, fullPath);
  }
}
